export default "__VITE_ASSET__BITuWFLU__"